import loadable from '@loadable/component';

export const DigitalcameraworldSiteWrapper = loadable(
  () => import(/* webpackChunkName: "digitalcameraworld-site" */ './DigitalcameraworldSiteWrapper'),
);
